import { useState } from "react";
import { apiFetch, apiFetchBlob } from "@/lib/api/client";
import { capturePrivateSession, assertPrivateSessionLifetime } from "@/lib/api/private-session";

/** Retained form/action callbacks belong to their mounted private identity. */
export function usePrivateApi() {
  const [bound] = useState(bindPrivateApi);
  return bound;
}
export function bindPrivateApi() {
  const lifetime = capturePrivateSession();
  async function fetch<T>(path: string, options?: Parameters<typeof apiFetch>[1]): Promise<T> {
    assertPrivateSessionLifetime(lifetime);
    const result = await apiFetch<T>(path, options);
    assertPrivateSessionLifetime(lifetime);
    return result;
  }
  const blob: typeof apiFetchBlob = async path => {
    assertPrivateSessionLifetime(lifetime);
    const result = await apiFetchBlob(path);
    assertPrivateSessionLifetime(lifetime);
    return result;
  };
  return { apiFetch: fetch, apiFetchBlob: blob };
}
